import React from 'react';
import styles from './InformPopup.scss';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { setPopUp } from 'actions/environment';
import { useDispatch } from 'react-redux';

export const InformPopupContent = ({ type, onOkButtonClick }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const handleButtonClick = () => {
    dispatch(setPopUp());
    if (type === 'userAlreadyExists') {
      onOkButtonClick();
    }
  };

  return (<div>
    <div className={styles.PopupContent}>
      <div>
        <div className={styles.PopupTitle}>
          {t(`components.profile.profileForm.informPopup.${type}Title`)}
        </div>
        <div className={styles.Divider} />
        <div className={styles.PopupSubtitle}>
          {t(`components.profile.profileForm.informPopup.${type}Subtitle`)}
        </div>
        <button
          className={cn(
					styles.ActionBtn,
					styles.LeaveAgencyButton,
					'button-primary',
					'button-primary--md'
				)}
          onClick={handleButtonClick}
        >
          {t(`components.profile.profileForm.informPopup.${type}Button`)}
        </button>
      </div>
    </div>
  </div>);
};



// WEBPACK FOOTER //
// ./src/components/Profile/InformPopup/InformPopup.jsx